import { render, staticRenderFns } from "./toDoCompletedNotificationItem.vue?vue&type=template&id=e8fbfb3c"
import script from "./toDoCompletedNotificationItem.vue?vue&type=script&lang=ts"
export * from "./toDoCompletedNotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports